import TuitionPaymentBlock from './TuitionPaymentBlock';
import { TuitionPaymentBlockProps, TuitionPaymentBlockValueProps } from './types';

export type { TuitionPaymentBlockProps, TuitionPaymentBlockValueProps };
export default TuitionPaymentBlock;
